// Module
var code = "<template> <div class=\"sortable\"> <slot></slot> <i class=\"ms-1 fas ${iconClass}\"></i> </div> </template> ";
// Exports
export default code;